import intlTelInput from 'intl-tel-input';

class CountryPhonePlugin {

    constructor(selector) {

        this.selector = selector;
        this.hiddenName = 'phoneNumber';

        var countryData = window.intlTelInputGlobals.getCountryData(),
        input = document.querySelector(this.selector);

        // BC contains non existant countries like Antartica, to allow for this
        countryData.push({ name: 'empty', iso2: 'zz', dialCode: '', priority: 0, areaCodes: null });
        //only add phoneNumber field if it doesn't already exist
        if (!$('[name="phoneNumber"]').length) {
            this.iti = intlTelInput(input, {
                hiddenInput: this.hiddenName,
                utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@17.0.19/build/js/utils.js"
            });
        }

        this.countryData = countryData;

        $(this.selector).on('change', () => {
            this.updateHiddenInput();
        });

        setTimeout(function () {
            $(selector).trigger('change', {countryPhonePluginAutoTrigger: true});
        }, 2000);

        let self = this;

        input.addEventListener("countrychange", function() {
            self.updateHiddenInput();
        });
    }

    updateHiddenInput() {
        let fullNumber = this.iti.getNumber();

        var countryPhone = this.iti.getSelectedCountryData();

        if (countryPhone.dialCode !== '' && !fullNumber.startsWith("+")) {
            fullNumber = `+${countryPhone.dialCode}${fullNumber}`;
        }

        $(this.selector).next('[name="' + this.hiddenName + '"]').val(fullNumber);
    }

    setCountry(countryCode) {
        if(typeof countryCode !== "undefined") {
            let found = false;
            for (let i = 0; i < this.countryData.length; i++){
                if (this.countryData[i].iso2 === countryCode.toLowerCase()) {
                    found = true;
                    this.iti.setCountry(countryCode);
                }
            }

            if (!found) {
                this.iti.setCountry('zz');
            }

            this.updateHiddenInput();
        }
    }

    getNumber() {
        return this.iti.getNumber();
    }
}

export default CountryPhonePlugin;
